// Dunning Saga
import { call, put, takeEvery, all } from "redux-saga/effects";

import {
  GET_DUNNING_LIST,
  GET_DUNNING_ACTION_LIST,
  CREATE_DUNNING_EVENT,
  SEARCH_SINGLE_CUSTOMER_DUNNING_EVENT_LIST,
  GET_DUNNING_SINGLE_EVENT,
  UPDATE_DUNNING_EVENT,
  DELETE_DUNNING_EVENT,
  ADD_NEW_DUNNING_EVENT_ACTION,
  UPDATE_DUNNING_EVENT_ACTION,
  DELETE_DUNNING_EVENT_ACTION,
  GET_DUNNING_LOCK_TYPE_LIST,
  GET_DUNNING_LOCK_TYPE_DATA,
  CREATE_DUNNING_LOCK_TYPE,
  UPDATE_DUNNING_LOCK_TYPE,
  DELETE_DUNNING_LOCK_TYPE,
  GET_DUNNING_LOCK_LIST,
  GET_DUNNING_LOCK_DATA,
  CREATE_DUNNING_LOCK,
  UPDATE_DUNNING_LOCK,
  DELETE_DUNNING_LOCK,
  GET_DUNNING_PROFILE_LIST,
  GET_DUNNING_PROFILE_DATA,
  CREATE_DUNNING_PROFILE,
  UPDATE_DUNNING_PROFILE,
  DELETE_DUNNING_PROFILE,
  GET_DUNNING_PROFILE_STEP_LIST,
  GET_DUNNING_PROFILE_STEP_DATA,
  CREATE_DUNNING_PROFILE_STEP,
  UPDATE_DUNNING_PROFILE_STEP,
  DELETE_DUNNING_PROFILE_STEP,
} from "./actionType";
import {
  getDunningListSuccess,
  getDunningListFailure,
  getDunningActionListSuccess,
  getDunningActionListFailure,
  createDunningEventSuccess,
  createDunningEventFailure,
  searchSingleCustomerDunningEventListSuccess,
  searchSingleCustomerDunningEventListFailure,
  getDunningSingleEventSuccess,
  getDunningSingleEventFailure,
  updateDunningEventSuccess,
  updateDunningEventFailure,
  deleteDunningEventSuccess,
  deleteDunningEventFailure,
  addNewDunningEventActionSuccess,
  addNewDunningEventActionFailure,
  updateDunningEventActionSuccess,
  updateDunningEventActionFailure,
  deleteDunningEventActionSuccess,
  deleteDunningEventActionFailure,
  getDunningLockTypeListSuccess,
  getDunningLockTypeListFailure,
  getDunningLockTypeDataSuccess,
  getDunningLockTypeDataFailure,
  createDunningLockTypeSuccess,
  createDunningLockTypeFailure,
  updateDunningLockTypeSuccess,
  updateDunningLockTypeFailure,
  deleteDunningLockTypeSuccess,
  deleteDunningLockTypeFailure,
  getDunningLockListSuccess,
  getDunningLockListFailure,
  getDunningLockDataSuccess,
  getDunningLockDataFailure,
  createDunningLockSuccess,
  createDunningLockFailure,
  updateDunningLockSuccess,
  updateDunningLockFailure,
  deleteDunningLockSuccess,
  deleteDunningLockFailure,
  getDunningProfileListSuccess,
  getDunningProfileListFailure,
  getDunningProfileDataSuccess,
  getDunningProfileDataFailure,
  createDunningProfileSuccess,
  createDunningProfileFailure,
  updateDunningProfileSuccess,
  updateDunningProfileFailure,
  deleteDunningProfileSuccess,
  deleteDunningProfileFailure,
  getDunningProfileStepListSuccess,
  getDunningProfileStepListFailure,
  getDunningProfileStepDataSuccess,
  getDunningProfileStepDataFailure,
  createDunningProfileStepSuccess,
  createDunningProfileStepFailure,
  updateDunningProfileStepSuccess,
  updateDunningProfileStepFailure,
  deleteDunningProfileStepSuccess,
  deleteDunningProfileStepFailure,
} from "./action";
import {
  getDunningListApi,
  getDunningActionListApi,
  createDunningEventApi,
  searchSingleCustomerDunningEventListApi,
  getDunningSingleEventApi,
  updateDunningEventApi,
  deleteDunningEventApi,
  addNewDunningEventActionApi,
  updateDunningEventActionApi,
  deleteDunningEventActionApi,
  getDunningLockTypeListApi,
  getDunningLockTypeDataApi,
  createDunningLockTypeApi,
  updateDunningLockTypeApi,
  deleteDunningLockTypeApi,
  getDunningLockListApi,
  getDunningLockDataApi,
  createDunningLockApi,
  updateDunningLockApi,
  deleteDunningLockApi,
  getDunningProfileListApi,
  getDunningProfileDataApi,
  createDunningProfileApi,
  updateDunningProfileApi,
  deleteDunningProfileApi,
  getDunningProfileStepListApi,
  getDunningProfileStepDataApi,
  createDunningProfileStepApi,
  updateDunningProfileStepApi,
  deleteDunningProfileStepApi,
} from "../../helpers/fakebackend_helper";

// Get Dunning List
function* getDunningList() {
  try {
    const response = yield call(getDunningListApi);
    yield put(getDunningListSuccess(response));
  } catch (error) {
    yield put(getDunningListFailure(error));
  }
}

export function* watchDunningList() {
  yield all([takeEvery(GET_DUNNING_LIST, getDunningList)]);
}

// Get Dunning Action List
function* getDunningActionList() {
  try {
    const response = yield call(getDunningActionListApi);
    yield put(getDunningActionListSuccess(response));
  } catch (error) {
    yield put(getDunningActionListFailure(error));
  }
}

export function* watchDunningActionList() {
  yield all([takeEvery(GET_DUNNING_ACTION_LIST, getDunningActionList)]);
}

// Create Dunning Event
function* createDunningEvent({ payload }) {
  try {
    const response = yield call(createDunningEventApi, payload);
    yield put(createDunningEventSuccess(response));
  } catch (error) {
    yield put(createDunningEventFailure(error));
  }
}

// Get Dunning Single Event
function* getDunningSingleEvent({ payload }) {
  try {
    const response = yield call(getDunningSingleEventApi, payload);
    yield put(getDunningSingleEventSuccess(response));
  } catch (error) {
    yield put(getDunningSingleEventFailure(error));
  }
}

export function* watchGetDunningSingleEvent() {
  yield all([takeEvery(GET_DUNNING_SINGLE_EVENT, getDunningSingleEvent)]);
}

// Update Dunning Event
function* updateDunningEvent({ payload }) {
  try {
    const response = yield call(updateDunningEventApi, payload);
    yield put(updateDunningEventSuccess(response));
  } catch (error) {
    yield put(updateDunningEventFailure(error));
  }
}

export function* watchUpdateDunningEvent() {
  yield all([takeEvery(UPDATE_DUNNING_EVENT, updateDunningEvent)]);
}

// Delete Dunning Event
function* deleteDunningEvent({ payload }) {
  try {
    const response = yield call(deleteDunningEventApi, payload);
    yield put(deleteDunningEventSuccess(response));
  } catch (error) {
    yield put(deleteDunningEventFailure(error));
  }
}

export function* watchDeleteDunningEvent() {
  yield all([takeEvery(DELETE_DUNNING_EVENT, deleteDunningEvent)]);
}

export function* watchCreateDunningEvent() {
  yield all([takeEvery(CREATE_DUNNING_EVENT, createDunningEvent)]);
}

// Search Single Customer Dunning Event List
function* searchSingleCustomerDunningEventList({ payload }) {
  try {
    const response = yield call(
      searchSingleCustomerDunningEventListApi,
      payload
    );
    yield put(searchSingleCustomerDunningEventListSuccess(response));
  } catch (error) {
    yield put(searchSingleCustomerDunningEventListFailure(error));
  }
}

export function* watchSearchSingleCustomerDunningEventList() {
  yield all([
    takeEvery(
      SEARCH_SINGLE_CUSTOMER_DUNNING_EVENT_LIST,
      searchSingleCustomerDunningEventList
    ),
  ]);
}

// Add New Dunning Event Action
function* addNewDunningEventAction({ payload }) {
  try {
    const response = yield call(addNewDunningEventActionApi, payload);
    yield put(addNewDunningEventActionSuccess(response));
  } catch (error) {
    yield put(addNewDunningEventActionFailure(error));
  }
}

export function* watchAddNewDunningEventAction() {
  yield all([
    takeEvery(ADD_NEW_DUNNING_EVENT_ACTION, addNewDunningEventAction),
  ]);
}

// Update Dunning Event Action
function* updateDunningEventAction({ payload }) {
  try {
    const response = yield call(updateDunningEventActionApi, payload);
    yield put(updateDunningEventActionSuccess(response));
  } catch (error) {
    yield put(updateDunningEventActionFailure(error));
  }
}

export function* watchUpdateDunningEventAction() {
  yield all([takeEvery(UPDATE_DUNNING_EVENT_ACTION, updateDunningEventAction)]);
}

// Delete Dunning Event Action
function* deleteDunningEventAction({ payload }) {
  try {
    const response = yield call(deleteDunningEventActionApi, payload);
    yield put(deleteDunningEventActionSuccess(response));
  } catch (error) {
    yield put(deleteDunningEventActionFailure(error));
  }
}

export function* watchDeleteDunningEventAction() {
  yield all([takeEvery(DELETE_DUNNING_EVENT_ACTION, deleteDunningEventAction)]);
}

//Getting Dunning Lock Type List
function* getDunningLockTypeList() {
  try {
    const response = yield call(getDunningLockTypeListApi);
    yield put(getDunningLockTypeListSuccess(response));
  } catch (error) {
    yield put(getDunningLockTypeListFailure(error));
  }
}

export function* watchGetDunningLockTypeList() {
  yield all([takeEvery(GET_DUNNING_LOCK_TYPE_LIST, getDunningLockTypeList)]);
}

//getting Dunning Lock Type Data
function* getDunningLockTypeData({ payload }) {
  try {
    const response = yield call(getDunningLockTypeDataApi, payload);
    yield put(getDunningLockTypeDataSuccess(response));
  } catch (error) {
    yield put(getDunningLockTypeDataFailure(error));
  }
}

export function* watchGetDunningLockTypeData() {
  yield all([takeEvery(GET_DUNNING_LOCK_TYPE_DATA, getDunningLockTypeData)]);
}

//Creating Dunning Lock Type
function* createDunningLockType({ payload }) {
  try {
    const response = yield call(createDunningLockTypeApi, payload);
    yield put(createDunningLockTypeSuccess(response));
  } catch (error) {
    yield put(createDunningLockTypeFailure(error));
  }
}

export function* watchCreateDunningLockType() {
  yield all([takeEvery(CREATE_DUNNING_LOCK_TYPE, createDunningLockType)]);
}

//update Dunning Lock Type
function* updateDunningLockType({ payload }) {
  try {
    const response = yield call(updateDunningLockTypeApi, payload);
    yield put(updateDunningLockTypeSuccess(response));
  } catch (error) {
    yield put(updateDunningLockTypeFailure(error));
  }
}

export function* watchUpdateDunningLockType() {
  yield all([takeEvery(UPDATE_DUNNING_LOCK_TYPE, updateDunningLockType)]);
}

//delete Dunning Lock Type
function* deleteDunningLockType({ payload }) {
  try {
    const response = yield call(deleteDunningLockTypeApi, payload);
    yield put(deleteDunningLockTypeSuccess(response));
  } catch (error) {
    yield put(deleteDunningLockTypeFailure(error));
  }
}

export function* watchDeleteDunningLockType() {
  yield all([takeEvery(DELETE_DUNNING_LOCK_TYPE, deleteDunningLockType)]);
}

// Getting Dunning Lock List
function* getDunningLockList() {
  try {
    const response = yield call(getDunningLockListApi);
    yield put(getDunningLockListSuccess(response));
  } catch (error) {
    yield put(getDunningLockListFailure(error));
  }
}

export function* watchGetDunningLockList() {
  yield all([takeEvery(GET_DUNNING_LOCK_LIST, getDunningLockList)]);
}

// Getting Dunning Lock Data
function* getDunningLockData({ payload }) {
  try {
    const response = yield call(getDunningLockDataApi, payload);
    yield put(getDunningLockDataSuccess(response));
  } catch (error) {
    yield put(getDunningLockDataFailure(error));
  }
}

export function* watchGetDunningLockData() {
  yield all([takeEvery(GET_DUNNING_LOCK_DATA, getDunningLockData)]);
}

// Creating Dunning Lock
function* createDunningLock({ payload }) {
  try {
    const response = yield call(createDunningLockApi, payload);
    yield put(createDunningLockSuccess(response));
  } catch (error) {
    yield put(createDunningLockFailure(error));
  }
}

export function* watchCreateDunningLock() {
  yield all([takeEvery(CREATE_DUNNING_LOCK, createDunningLock)]);
}

// Updating Dunning Lock
function* updateDunningLock({ payload }) {
  try {
    const response = yield call(updateDunningLockApi, payload);
    yield put(updateDunningLockSuccess(response));
  } catch (error) {
    yield put(updateDunningLockFailure(error));
  }
}

export function* watchUpdateDunningLock() {
  yield all([takeEvery(UPDATE_DUNNING_LOCK, updateDunningLock)]);
}

// Deleting Dunning Lock
function* deleteDunningLock({ payload }) {
  try {
    const response = yield call(deleteDunningLockApi, payload);
    yield put(deleteDunningLockSuccess(response));
  } catch (error) {
    yield put(deleteDunningLockFailure(error));
  }
}

export function* watchDeleteDunningLock() {
  yield all([takeEvery(DELETE_DUNNING_LOCK, deleteDunningLock)]);
}

// Getting Dunning Profile List
function* getDunningProfileList() {
  try {
    const response = yield call(getDunningProfileListApi);
    yield put(getDunningProfileListSuccess(response));
  } catch (error) {
    yield put(getDunningProfileListFailure(error));
  }
}

export function* watchGetDunningProfileList() {
  yield all([takeEvery(GET_DUNNING_PROFILE_LIST, getDunningProfileList)]);
}

// Getting Dunning Profile Data
function* getDunningProfileData({ payload }) {
  try {
    const response = yield call(getDunningProfileDataApi, payload);
    yield put(getDunningProfileDataSuccess(response));
  } catch (error) {
    yield put(getDunningProfileDataFailure(error));
  }
}

export function* watchGetDunningProfileData() {
  yield all([takeEvery(GET_DUNNING_PROFILE_DATA, getDunningProfileData)]);
}

// Creating Dunning Profile
function* createDunningProfile({ payload }) {
  try {
    const response = yield call(createDunningProfileApi, payload);
    yield put(createDunningProfileSuccess(response));
  } catch (error) {
    yield put(createDunningProfileFailure(error));
  }
}

export function* watchCreateDunningProfile() {
  yield all([takeEvery(CREATE_DUNNING_PROFILE, createDunningProfile)]);
}

// Updating Dunning Profile
function* updateDunningProfile({ payload }) {
  try {
    const response = yield call(updateDunningProfileApi, payload);
    yield put(updateDunningProfileSuccess(response));
  } catch (error) {
    yield put(updateDunningProfileFailure(error));
  }
}

export function* watchUpdateDunningProfile() {
  yield all([takeEvery(UPDATE_DUNNING_PROFILE, updateDunningProfile)]);
}

// Deleting Dunning Profile
function* deleteDunningProfile({ payload }) {
  try {
    const response = yield call(deleteDunningProfileApi, payload);
    yield put(deleteDunningProfileSuccess(response));
  } catch (error) {
    yield put(deleteDunningProfileFailure(error));
  }
}

export function* watchDeleteDunningProfile() {
  yield all([takeEvery(DELETE_DUNNING_PROFILE, deleteDunningProfile)]);
}

// Getting Dunning Profile Step List
function* getDunningProfileStepList({ payload }) {
  try {
    const response = yield call(getDunningProfileStepListApi, payload);
    yield put(getDunningProfileStepListSuccess(response));
  } catch (error) {
    yield put(getDunningProfileStepListFailure(error));
  }
}

export function* watchGetDunningProfileStepList() {
  yield all([
    takeEvery(GET_DUNNING_PROFILE_STEP_LIST, getDunningProfileStepList),
  ]);
}

// Getting Dunning Profile Step Data
function* getDunningProfileStepData({ payload }) {
  try {
    const response = yield call(getDunningProfileStepDataApi, payload);
    yield put(getDunningProfileStepDataSuccess(response));
  } catch (error) {
    yield put(getDunningProfileStepDataFailure(error));
  }
}

export function* watchGetDunningProfileStepData() {
  yield all([
    takeEvery(GET_DUNNING_PROFILE_STEP_DATA, getDunningProfileStepData),
  ]);
}

// Creating Dunning Profile Step
function* createDunningProfileStep({ payload }) {
  try {
    const response = yield call(createDunningProfileStepApi, payload);
    yield put(createDunningProfileStepSuccess(response));
  } catch (error) {
    yield put(createDunningProfileStepFailure(error));
  }
}

export function* watchCreateDunningProfileStep() {
  yield all([takeEvery(CREATE_DUNNING_PROFILE_STEP, createDunningProfileStep)]);
}

// Updating Dunning Profile Step
function* updateDunningProfileStep({ payload }) {
  try {
    const response = yield call(updateDunningProfileStepApi, payload);
    yield put(updateDunningProfileStepSuccess(response));
  } catch (error) {
    yield put(updateDunningProfileStepFailure(error));
  }
}

export function* watchUpdateDunningProfileStep() {
  yield all([takeEvery(UPDATE_DUNNING_PROFILE_STEP, updateDunningProfileStep)]);
}

// Deleting Dunning Profile Step
function* deleteDunningProfileStep({ payload }) {
  try {
    const response = yield call(deleteDunningProfileStepApi, payload);
    yield put(deleteDunningProfileStepSuccess(response));
  } catch (error) {
    yield put(deleteDunningProfileStepFailure(error));
  }
}

export function* watchDeleteDunningProfileStep() {
  yield all([takeEvery(DELETE_DUNNING_PROFILE_STEP, deleteDunningProfileStep)]);
}

// Main function export
export default function* Dunning() {
  yield all([
    watchDunningList(),
    watchDunningActionList(),
    watchCreateDunningEvent(),
    watchGetDunningSingleEvent(),
    watchUpdateDunningEvent(),
    watchDeleteDunningEvent(),
    watchSearchSingleCustomerDunningEventList(),
    watchAddNewDunningEventAction(),
    watchUpdateDunningEventAction(),
    watchDeleteDunningEventAction(),
    watchGetDunningLockTypeList(),
    watchGetDunningLockTypeData(),
    watchCreateDunningLockType(),
    watchUpdateDunningLockType(),
    watchDeleteDunningLockType(),
    watchGetDunningLockList(),
    watchGetDunningLockData(),
    watchCreateDunningLock(),
    watchUpdateDunningLock(),
    watchDeleteDunningLock(),
    watchGetDunningProfileList(),
    watchGetDunningProfileData(),
    watchCreateDunningProfile(),
    watchUpdateDunningProfile(),
    watchDeleteDunningProfile(),
    watchGetDunningProfileStepList(),
    watchGetDunningProfileStepData(),
    watchCreateDunningProfileStep(),
    watchUpdateDunningProfileStep(),
    watchDeleteDunningProfileStep(),
  ]);
}
